import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {configTagsView_template} from "../components/templates/configTagsView_template";

declare var ko: any;
declare var page: any;

export class config_tags_view extends vnModule_knockoutJS{

    protected viewForm: configTagsView_template;
    protected XHRHdl: XMLHttpRequestHandler;

    protected getModuleName(): string{

        return "config_tags_view";
    }

    buildContent(): Array<Element>{

        this.viewForm = new configTagsView_template("view_template", this.viewModel, this);
        return [this.viewForm.build()];
    }

    public fillPage(): void{

        this.getTag();
    }

    protected getTag(){

        this.loadingIn(this.viewForm.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        let idTag = this.getVnAppZone().getApp().params.idTag;

        let usrReq_url: string = '/api/brand/' + idBrand + "/tags/get/"+idTag;

        let usrReq_params: Array<Array<string>> = [];

        let vm = this.viewForm.getViewModelForRequest();

        usrReq_params.push(["data", ko.toJSON(vm)] );

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj){

        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.setTag(responseParsed.data);
            });

            obj.loadingOut(obj.viewForm.builtTemplate);
        }
    }

    public setTag(data): void{

        this.viewForm.setId(data.id);
        this.viewForm.setName(data.name);

        if(data.details){

            this.viewForm.setSlug(data.details.slug);
            this.viewForm.setDescription(data.details.description);
            this.viewForm.setIsSelectable(data.details.isSelectable ? true : false);
            this.viewForm.setDateCreated(data.details.dateCreated.substring(0,10));
        }


    }


    protected edit(id){

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect('/brand/' + idBrand + "/categorization/tags/edit/" + id);

    }

    protected cancel(){

        let idBrand = this.getVnAppZone().getApp().params.idBrand;
        page.redirect('/brand/' + idBrand + "/categorization/tags/");
    }

}


// WEBPACK FOOTER //
// ./js/modules/config_tags_view.ts